import { AddAvailabilityComponent } from './add-availability/add-availability.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListComponent } from './list/list.component';
import { AvailabilityResolverService } from './resolvers/availability-resolver.service';


const routes: Routes = [
  { path: '', component:ListComponent,data:{list:true,activeClass:"availability"}, resolve: { availabilities: AvailabilityResolverService } },
  { path: 'add', component:AddAvailabilityComponent, },
  { path: 'edit/:id', component:AddAvailabilityComponent,data:{edit:true,activeClass:"availability"}, resolve: { availability: AvailabilityResolverService } },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AvailabilityRoutingModule { }
